module.exports = __webpack_public_path__ + "img/vk.6669a7b0.svg";